import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "../InquiryReply.css";

class FileAttachment extends Component {

    render() {
        return (
            <div className="col-md-6 no-padding-left">
                <FormattedMessage id="app.inquiry-reply.attachment"
                                  defaultMessage="Attachments:"
                                  description=""/>&nbsp;&nbsp;&nbsp;
                <label>
                    {/*<FormattedMessage id="app.inquiry-reply.attach-file"
                     defaultMessage="Attach file..."
                     description="" />*/}
                    <input type="file" placeholder="no file" multiple/>
                </label>
            </div>
        )
    }
}
export default FileAttachment;


// WEBPACK FOOTER //
// ./src/components/Admin/InquiryReply/FileAttachment/FileAttachment.js